<template>
  <div class="messagebox">
    <transition name="fade">
      <div v-show="show" class="popup">
        <div class="content-box">
          <div class="poptitle">
            <h1>不通过原因</h1>
          </div>
          <div @scroll="move" class="popcontent">
            {{ rejectseason }}
            <div v-show="isScroll" :style="{ transform: opacityMove }" class="opacity"></div>
          </div>
          <div class="closeIcon" @click="modifyingdata">
            关闭
          </div>
        </div>
        <div class="mask" @click="modifyingdata"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "messagebox",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rejectseason: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      opacityMove: `translate(0, 0)`,
      isScroll: false
    }
  },
  methods: {
    modifyingdata() {
      document.querySelector("#app").style.overflow = "auto"
      this.$emit("input", false)
      setTimeout(() => {
        let ele = document.querySelector(".popcontent")
        ele.scrollTop = 0
      }, 500)
    },
    move(e) {
      if (e.target.scrollTop !== 0) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
      this.opacityMove = `translate(0, ${e.target.scrollTop}px)`
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.messagebox {
  z-index: 99999;
  .popup {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .content-box {
      position: relative;
      z-index: 99999;
      width: 6.4rem;
      background: #ffffff;
      padding-top: 0.4rem;
      border-radius: 0.2rem;
      .poptitle {
        h1 {
          font-family: PingFangSC-Medium;
          width: 100%;
          text-align: center;
          font-size: 0.36rem;
          color: #333333;
          letter-spacing: 0;
          font-weight: normal;
        }
      }
      .popcontent {
        font-family: PingFangSC-Regular;
        font-size: 0.3rem;
        color: #333333;
        letter-spacing: 0;
        max-height: 7rem;
        overflow: auto;
        margin: 0;
        padding: 0 0.5rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        padding-bottom: 0.4rem;
        position: relative;
        .opacity {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 6;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 5%);
          pointer-events: none;
        }
      }
      .closeIcon {
        width: 100%;
        height: 0.94rem;
        font-family: PingFangSC-Regular;
        font-size: 0.34rem;
        color: #50a9fd;
        letter-spacing: 0;
        text-align: center;
        border-top: 1px solid #dddddd;
        line-height: 0.94rem;
      }
    }
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 6;
    }
  }
}
</style>
